import { appSettings } from 'settings/app-settings'

export const Laba = () => {
  return (
    <a href={appSettings.urls.REACT_APP_LAB_URL} rel={'noopener noreferrer'} target={'_blank'}>
      laba
    </a>
  )
}
